import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class QueryStateService {
  private loadedQuerySource = new Subject<string>();
  loadedQuery$ = this.loadedQuerySource.asObservable();

  emitLoadedQuery(query: string) {
    this.loadedQuerySource.next(query);
  }
}
